module.exports = __webpack_public_path__ + "static/media/line.8645f475.svg";